import { render } from "./UpdateProduct.vue?vue&type=template&id=10273cd8&ts=true"
import script from "./UpdateProduct.vue?vue&type=script&lang=ts"
export * from "./UpdateProduct.vue?vue&type=script&lang=ts"

import "./UpdateProduct.vue?vue&type=style&index=0&id=10273cd8&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__